/* Codressing: homepage Google reviews (Gropulse app block, styles in assets/cd-reviews.css). The widget has no per-review
   number, so this adds the score after each card's star row ("5.0"): it counts the filled (yellow, #fbbc04 /
   rgb(251,188,4)) stars. Only runs inside the homepage reviews section; idempotent; re-runs when the app renders late. */
(function () {
  if (window.__cdReviews) return;
  window.__cdReviews = true;
  var SEC = '[id$="__1729518455e5a1a145"]';

  function isFilled(el) {
    var f = ((el.getAttribute('fill') || '') + ' ' + (el.getAttribute('style') || '')).toLowerCase().replace(/ /g, '');
    return f.indexOf('251,188,4') > -1 || f.indexOf('fbbc04') > -1;
  }
  function score(row) {
    var stars = row.querySelectorAll('svg svg');
    var n = 0;
    if (stars.length) {
      for (var i = 0; i < stars.length; i++) {
        var p = stars[i].querySelector('path');
        if (p && isFilled(p)) n++;
      }
    } else {
      var ps = row.querySelectorAll('path');
      for (var j = 0; j < ps.length; j++) if (isFilled(ps[j])) n++;
    }
    return n;
  }
  function run() {
    var sec = document.querySelector(SEC);
    if (!sec) return;
    var rows = sec.querySelectorAll('.ht-google-place-rating-star');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var n = score(row);
      if (!n) continue;
      var txt = n.toFixed(1);
      var next = row.nextElementSibling;
      if (next && next.classList.contains('cd-review-score')) {
        if (next.textContent !== txt) next.textContent = txt;
        continue;
      }
      var s = document.createElement('span');
      s.className = 'cd-review-score';
      s.textContent = txt;
      row.insertAdjacentElement('afterend', s);
    }
  }
  var t = null;
  function later() { clearTimeout(t); t = setTimeout(run, 150); }
  function start() {
    run();
    var sec = document.querySelector(SEC);
    if (sec && window.MutationObserver) new MutationObserver(later).observe(sec, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', later);
})();
